/*
 * @Author: w9013327 v-maijiahua@oppo.com
 * @Date: 2023-02-21 16:47:42
 * @LastEditors: w9013327 v-maijiahua@oppo.com
 * @LastEditTime: 2023-02-27 14:52:42
 * @FilePath: \sns-user-frontend\src\directive\LongPress.js
 * @Description: 
 */
const LongPress = {
  // 组件mounted时执行指令
  mounted(el, binding, vNode) {
    el.tapObj = {}
    // 确保提供的表达式是函数
    if (typeof binding.value !== 'function') {
      // // 将警告传递给控制台
      let warn = `[longpress:] provided expression '${binding.value}' is not afunction, but has to be `
    } else {
      let timer = null  //定义空 定时器
      const start = (e) => {
        !document.querySelector('.van-overflow-hidden') && e.stopPropagation()
        // e.stopPropagation()
        //下列事件不执行1.不是鼠标左键2.单击事件  (3.没有传入长按时间 ?? 有默认)
        if ((e.button !== 0 && e.type === 'click') || timer) {
          return
        }
        let touches = e.touches[0]
        el.tapObj.pageX = touches.pageX
        el.tapObj.pageY = touches.pageY
        el.tapObj.clientX = touches.clientX
        el.tapObj.clientY = touches.clientY
        if (timer == null) {
          timer = setTimeout(() => {
            handler()
          }, 900) //默认长按0.5秒执行绑定的函数
        }
      }
      const cancel = (e) => {
        if (timer !== null) {
          clearTimeout(timer)
          timer = null
        }
      }
      const handler = (val) => {
        binding.value(el)
      }
      // 添加事件监听器
      el.addEventListener('touchstart', start)
      el.addEventListener('touchmove', cancel)
      // 取消计时器
      el.addEventListener('touchend', cancel)
    }
  }
}
 
export default LongPress